/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as MobilePushRouteImport } from './routes/mobile-push'
import { Route as MobileSmsRouteImport } from './routes/mobile-sms'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppOrganizationRouteRouteImport } from './routes/_app/organization/route'
import { Route as AppProjectsRouteRouteImport } from './routes/_app/projects/route'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminEmailAbuseRouteImport } from './routes/admin/email-abuse'
import { Route as AdminOrganizationsRouteImport } from './routes/admin/organizations'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AuthAuthViewRouteImport } from './routes/auth/$authView'
import { Route as McpAuthorizeRouteImport } from './routes/mcp/authorize'
import { Route as McpSignInRouteImport } from './routes/mcp/sign-in'
import { Route as AppAccountIndexRouteImport } from './routes/_app/account/index'
import { Route as AppAccountAccountViewRouteImport } from './routes/_app/account/$accountView'
import { Route as AppCliProjectSelectSessionIdRouteImport } from './routes/_app/cli-project-select/$sessionId'
import { Route as AppOrganizationIndexRouteImport } from './routes/_app/organization/index'
import { Route as AppOrganizationApiKeysRouteImport } from './routes/_app/organization/api-keys'
import { Route as AppOrganizationBillingRouteImport } from './routes/_app/organization/billing'
import { Route as AppOrganizationMcpRouteImport } from './routes/_app/organization/mcp'
import { Route as AppOrganizationMembersRouteImport } from './routes/_app/organization/members'
import { Route as AppOrganizationSendingRouteImport } from './routes/_app/organization/sending'
import { Route as AppOrganizationSettingsRouteImport } from './routes/_app/organization/settings'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppCliAuthSessionIdIndexRouteImport } from './routes/_app/cli-auth/$sessionId/index'
import { Route as AppProjectsProjectSlugLayoutRouteRouteImport } from './routes/_app/projects/$projectSlug/_layout/route'
import { Route as AppCliAuthSessionIdCompleteIndexRouteImport } from './routes/_app/cli-auth/$sessionId/complete/index'
import { Route as AppCliAuthSessionIdCompleteOrganizationSlugRouteImport } from './routes/_app/cli-auth/$sessionId/complete/$organizationSlug'
import { Route as AppProjectsProjectSlugLayoutIndexRouteImport } from './routes/_app/projects/$projectSlug/_layout/index'
import { Route as AppProjectsProjectSlugLayoutAboutRouteImport } from './routes/_app/projects/$projectSlug/_layout/about'
import { Route as AppProjectsProjectSlugLayoutLogsRouteImport } from './routes/_app/projects/$projectSlug/_layout/logs'
import { Route as AppProjectsProjectSlugLayoutMediaRouteImport } from './routes/_app/projects/$projectSlug/_layout/media'
import { Route as AppProjectsProjectSlugLayoutSendingRouteImport } from './routes/_app/projects/$projectSlug/_layout/sending'
import { Route as AppProjectsProjectSlugLayoutSettingsRouteImport } from './routes/_app/projects/$projectSlug/_layout/settings'
import { Route as AppProjectsProjectSlugLayoutVirtualInboxRouteImport } from './routes/_app/projects/$projectSlug/_layout/virtual-inbox'
import { Route as AppProjectsProjectSlugTemplatesIndexRouteImport } from './routes/_app/projects/$projectSlug/templates/index'
import { Route as AppProjectsProjectSlugTemplatesTemplateSlugIndexRouteImport } from './routes/_app/projects/$projectSlug/templates/$templateSlug/index'
import { Route as AppProjectsProjectSlugTemplatesTemplateSlugEditRouteImport } from './routes/_app/projects/$projectSlug/templates/$templateSlug/edit'
import { Route as AppProjectsProjectSlugTemplatesTemplateSlugLogsRouteImport } from './routes/_app/projects/$projectSlug/templates/$templateSlug/logs'
import { Route as AppProjectsProjectSlugTemplatesTemplateSlugReviewRouteImport } from './routes/_app/projects/$projectSlug/templates/$templateSlug/review'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const MobilePushRoute = MobilePushRouteImport.update({
  id: '/mobile-push',
  path: '/mobile-push',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileSmsRoute = MobileSmsRouteImport.update({
  id: '/mobile-sms',
  path: '/mobile-sms',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOrganizationRouteRoute = AppOrganizationRouteRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProjectsRouteRoute = AppProjectsRouteRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AppRouteRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminEmailAbuseRoute = AdminEmailAbuseRouteImport.update({
  id: '/email-abuse',
  path: '/email-abuse',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminOrganizationsRoute = AdminOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AuthAuthViewRoute = AuthAuthViewRouteImport.update({
  id: '/auth/$authView',
  path: '/auth/$authView',
  getParentRoute: () => rootRouteImport,
} as any)
const McpAuthorizeRoute = McpAuthorizeRouteImport.update({
  id: '/mcp/authorize',
  path: '/mcp/authorize',
  getParentRoute: () => rootRouteImport,
} as any)
const McpSignInRoute = McpSignInRouteImport.update({
  id: '/mcp/sign-in',
  path: '/mcp/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAccountAccountViewRoute = AppAccountAccountViewRouteImport.update({
  id: '/account/$accountView',
  path: '/account/$accountView',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCliProjectSelectSessionIdRoute =
  AppCliProjectSelectSessionIdRouteImport.update({
    id: '/cli-project-select/$sessionId',
    path: '/cli-project-select/$sessionId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppOrganizationIndexRoute = AppOrganizationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppOrganizationApiKeysRoute = AppOrganizationApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppOrganizationBillingRoute = AppOrganizationBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppOrganizationMcpRoute = AppOrganizationMcpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppOrganizationMembersRoute = AppOrganizationMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppOrganizationSendingRoute = AppOrganizationSendingRouteImport.update({
  id: '/sending',
  path: '/sending',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppOrganizationSettingsRoute = AppOrganizationSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppOrganizationRouteRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProjectsRouteRoute,
} as any)
const AppCliAuthSessionIdIndexRoute =
  AppCliAuthSessionIdIndexRouteImport.update({
    id: '/cli-auth/$sessionId/',
    path: '/cli-auth/$sessionId/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppProjectsProjectSlugLayoutRouteRoute =
  AppProjectsProjectSlugLayoutRouteRouteImport.update({
    id: '/$projectSlug/_layout',
    path: '/$projectSlug',
    getParentRoute: () => AppProjectsRouteRoute,
  } as any)
const AppCliAuthSessionIdCompleteIndexRoute =
  AppCliAuthSessionIdCompleteIndexRouteImport.update({
    id: '/cli-auth/$sessionId/complete/',
    path: '/cli-auth/$sessionId/complete/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCliAuthSessionIdCompleteOrganizationSlugRoute =
  AppCliAuthSessionIdCompleteOrganizationSlugRouteImport.update({
    id: '/cli-auth/$sessionId/complete/$organizationSlug',
    path: '/cli-auth/$sessionId/complete/$organizationSlug',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppProjectsProjectSlugLayoutIndexRoute =
  AppProjectsProjectSlugLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectSlugLayoutRouteRoute,
  } as any)
const AppProjectsProjectSlugLayoutAboutRoute =
  AppProjectsProjectSlugLayoutAboutRouteImport.update({
    id: '/about',
    path: '/about',
    getParentRoute: () => AppProjectsProjectSlugLayoutRouteRoute,
  } as any)
const AppProjectsProjectSlugLayoutLogsRoute =
  AppProjectsProjectSlugLayoutLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => AppProjectsProjectSlugLayoutRouteRoute,
  } as any)
const AppProjectsProjectSlugLayoutMediaRoute =
  AppProjectsProjectSlugLayoutMediaRouteImport.update({
    id: '/media',
    path: '/media',
    getParentRoute: () => AppProjectsProjectSlugLayoutRouteRoute,
  } as any)
const AppProjectsProjectSlugLayoutSendingRoute =
  AppProjectsProjectSlugLayoutSendingRouteImport.update({
    id: '/sending',
    path: '/sending',
    getParentRoute: () => AppProjectsProjectSlugLayoutRouteRoute,
  } as any)
const AppProjectsProjectSlugLayoutSettingsRoute =
  AppProjectsProjectSlugLayoutSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppProjectsProjectSlugLayoutRouteRoute,
  } as any)
const AppProjectsProjectSlugLayoutVirtualInboxRoute =
  AppProjectsProjectSlugLayoutVirtualInboxRouteImport.update({
    id: '/virtual-inbox',
    path: '/virtual-inbox',
    getParentRoute: () => AppProjectsProjectSlugLayoutRouteRoute,
  } as any)
const AppProjectsProjectSlugTemplatesIndexRoute =
  AppProjectsProjectSlugTemplatesIndexRouteImport.update({
    id: '/$projectSlug/templates/',
    path: '/$projectSlug/templates/',
    getParentRoute: () => AppProjectsRouteRoute,
  } as any)
const AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute =
  AppProjectsProjectSlugTemplatesTemplateSlugIndexRouteImport.update({
    id: '/$projectSlug/templates/$templateSlug/',
    path: '/$projectSlug/templates/$templateSlug/',
    getParentRoute: () => AppProjectsRouteRoute,
  } as any)
const AppProjectsProjectSlugTemplatesTemplateSlugEditRoute =
  AppProjectsProjectSlugTemplatesTemplateSlugEditRouteImport.update({
    id: '/$projectSlug/templates/$templateSlug/edit',
    path: '/$projectSlug/templates/$templateSlug/edit',
    getParentRoute: () => AppProjectsRouteRoute,
  } as any)
const AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute =
  AppProjectsProjectSlugTemplatesTemplateSlugLogsRouteImport.update({
    id: '/$projectSlug/templates/$templateSlug/logs',
    path: '/$projectSlug/templates/$templateSlug/logs',
    getParentRoute: () => AppProjectsRouteRoute,
  } as any)
const AppProjectsProjectSlugTemplatesTemplateSlugReviewRoute =
  AppProjectsProjectSlugTemplatesTemplateSlugReviewRouteImport.update({
    id: '/$projectSlug/templates/$templateSlug/review',
    path: '/$projectSlug/templates/$templateSlug/review',
    getParentRoute: () => AppProjectsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/mobile-push': typeof MobilePushRoute
  '/mobile-sms': typeof MobileSmsRoute
  '/organization': typeof AppOrganizationRouteRouteWithChildren
  '/projects': typeof AppProjectsRouteRouteWithChildren
  '/admin/email-abuse': typeof AdminEmailAbuseRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/$authView': typeof AuthAuthViewRoute
  '/mcp/authorize': typeof McpAuthorizeRoute
  '/mcp/sign-in': typeof McpSignInRoute
  '/admin/': typeof AdminIndexRoute
  '/account/$accountView': typeof AppAccountAccountViewRoute
  '/cli-project-select/$sessionId': typeof AppCliProjectSelectSessionIdRoute
  '/organization/api-keys': typeof AppOrganizationApiKeysRoute
  '/organization/billing': typeof AppOrganizationBillingRoute
  '/organization/mcp': typeof AppOrganizationMcpRoute
  '/organization/members': typeof AppOrganizationMembersRoute
  '/organization/sending': typeof AppOrganizationSendingRoute
  '/organization/settings': typeof AppOrganizationSettingsRoute
  '/account/': typeof AppAccountIndexRoute
  '/organization/': typeof AppOrganizationIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/projects/$projectSlug': typeof AppProjectsProjectSlugLayoutRouteRouteWithChildren
  '/cli-auth/$sessionId/': typeof AppCliAuthSessionIdIndexRoute
  '/cli-auth/$sessionId/complete/$organizationSlug': typeof AppCliAuthSessionIdCompleteOrganizationSlugRoute
  '/projects/$projectSlug/about': typeof AppProjectsProjectSlugLayoutAboutRoute
  '/projects/$projectSlug/logs': typeof AppProjectsProjectSlugLayoutLogsRoute
  '/projects/$projectSlug/media': typeof AppProjectsProjectSlugLayoutMediaRoute
  '/projects/$projectSlug/sending': typeof AppProjectsProjectSlugLayoutSendingRoute
  '/projects/$projectSlug/settings': typeof AppProjectsProjectSlugLayoutSettingsRoute
  '/projects/$projectSlug/virtual-inbox': typeof AppProjectsProjectSlugLayoutVirtualInboxRoute
  '/cli-auth/$sessionId/complete/': typeof AppCliAuthSessionIdCompleteIndexRoute
  '/projects/$projectSlug/': typeof AppProjectsProjectSlugLayoutIndexRoute
  '/projects/$projectSlug/templates/': typeof AppProjectsProjectSlugTemplatesIndexRoute
  '/projects/$projectSlug/templates/$templateSlug/edit': typeof AppProjectsProjectSlugTemplatesTemplateSlugEditRoute
  '/projects/$projectSlug/templates/$templateSlug/logs': typeof AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute
  '/projects/$projectSlug/templates/$templateSlug/review': typeof AppProjectsProjectSlugTemplatesTemplateSlugReviewRoute
  '/projects/$projectSlug/templates/$templateSlug/': typeof AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute
}
export interface FileRoutesByTo {
  '/mobile-push': typeof MobilePushRoute
  '/mobile-sms': typeof MobileSmsRoute
  '/admin/email-abuse': typeof AdminEmailAbuseRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/$authView': typeof AuthAuthViewRoute
  '/mcp/authorize': typeof McpAuthorizeRoute
  '/mcp/sign-in': typeof McpSignInRoute
  '/': typeof AppIndexRoute
  '/admin': typeof AdminIndexRoute
  '/account/$accountView': typeof AppAccountAccountViewRoute
  '/cli-project-select/$sessionId': typeof AppCliProjectSelectSessionIdRoute
  '/organization/api-keys': typeof AppOrganizationApiKeysRoute
  '/organization/billing': typeof AppOrganizationBillingRoute
  '/organization/mcp': typeof AppOrganizationMcpRoute
  '/organization/members': typeof AppOrganizationMembersRoute
  '/organization/sending': typeof AppOrganizationSendingRoute
  '/organization/settings': typeof AppOrganizationSettingsRoute
  '/account': typeof AppAccountIndexRoute
  '/organization': typeof AppOrganizationIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/cli-auth/$sessionId': typeof AppCliAuthSessionIdIndexRoute
  '/cli-auth/$sessionId/complete/$organizationSlug': typeof AppCliAuthSessionIdCompleteOrganizationSlugRoute
  '/projects/$projectSlug/about': typeof AppProjectsProjectSlugLayoutAboutRoute
  '/projects/$projectSlug/logs': typeof AppProjectsProjectSlugLayoutLogsRoute
  '/projects/$projectSlug/media': typeof AppProjectsProjectSlugLayoutMediaRoute
  '/projects/$projectSlug/sending': typeof AppProjectsProjectSlugLayoutSendingRoute
  '/projects/$projectSlug/settings': typeof AppProjectsProjectSlugLayoutSettingsRoute
  '/projects/$projectSlug/virtual-inbox': typeof AppProjectsProjectSlugLayoutVirtualInboxRoute
  '/cli-auth/$sessionId/complete': typeof AppCliAuthSessionIdCompleteIndexRoute
  '/projects/$projectSlug': typeof AppProjectsProjectSlugLayoutIndexRoute
  '/projects/$projectSlug/templates': typeof AppProjectsProjectSlugTemplatesIndexRoute
  '/projects/$projectSlug/templates/$templateSlug/edit': typeof AppProjectsProjectSlugTemplatesTemplateSlugEditRoute
  '/projects/$projectSlug/templates/$templateSlug/logs': typeof AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute
  '/projects/$projectSlug/templates/$templateSlug/review': typeof AppProjectsProjectSlugTemplatesTemplateSlugReviewRoute
  '/projects/$projectSlug/templates/$templateSlug': typeof AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/admin': typeof AdminRouteRouteWithChildren
  '/mobile-push': typeof MobilePushRoute
  '/mobile-sms': typeof MobileSmsRoute
  '/_app/organization': typeof AppOrganizationRouteRouteWithChildren
  '/_app/projects': typeof AppProjectsRouteRouteWithChildren
  '/admin/email-abuse': typeof AdminEmailAbuseRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/$authView': typeof AuthAuthViewRoute
  '/mcp/authorize': typeof McpAuthorizeRoute
  '/mcp/sign-in': typeof McpSignInRoute
  '/_app/': typeof AppIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/_app/account/$accountView': typeof AppAccountAccountViewRoute
  '/_app/cli-project-select/$sessionId': typeof AppCliProjectSelectSessionIdRoute
  '/_app/organization/api-keys': typeof AppOrganizationApiKeysRoute
  '/_app/organization/billing': typeof AppOrganizationBillingRoute
  '/_app/organization/mcp': typeof AppOrganizationMcpRoute
  '/_app/organization/members': typeof AppOrganizationMembersRoute
  '/_app/organization/sending': typeof AppOrganizationSendingRoute
  '/_app/organization/settings': typeof AppOrganizationSettingsRoute
  '/_app/account/': typeof AppAccountIndexRoute
  '/_app/organization/': typeof AppOrganizationIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/projects/$projectSlug/_layout': typeof AppProjectsProjectSlugLayoutRouteRouteWithChildren
  '/_app/cli-auth/$sessionId/': typeof AppCliAuthSessionIdIndexRoute
  '/_app/cli-auth/$sessionId/complete/$organizationSlug': typeof AppCliAuthSessionIdCompleteOrganizationSlugRoute
  '/_app/projects/$projectSlug/_layout/about': typeof AppProjectsProjectSlugLayoutAboutRoute
  '/_app/projects/$projectSlug/_layout/logs': typeof AppProjectsProjectSlugLayoutLogsRoute
  '/_app/projects/$projectSlug/_layout/media': typeof AppProjectsProjectSlugLayoutMediaRoute
  '/_app/projects/$projectSlug/_layout/sending': typeof AppProjectsProjectSlugLayoutSendingRoute
  '/_app/projects/$projectSlug/_layout/settings': typeof AppProjectsProjectSlugLayoutSettingsRoute
  '/_app/projects/$projectSlug/_layout/virtual-inbox': typeof AppProjectsProjectSlugLayoutVirtualInboxRoute
  '/_app/cli-auth/$sessionId/complete/': typeof AppCliAuthSessionIdCompleteIndexRoute
  '/_app/projects/$projectSlug/_layout/': typeof AppProjectsProjectSlugLayoutIndexRoute
  '/_app/projects/$projectSlug/templates/': typeof AppProjectsProjectSlugTemplatesIndexRoute
  '/_app/projects/$projectSlug/templates/$templateSlug/edit': typeof AppProjectsProjectSlugTemplatesTemplateSlugEditRoute
  '/_app/projects/$projectSlug/templates/$templateSlug/logs': typeof AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute
  '/_app/projects/$projectSlug/templates/$templateSlug/review': typeof AppProjectsProjectSlugTemplatesTemplateSlugReviewRoute
  '/_app/projects/$projectSlug/templates/$templateSlug/': typeof AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/mobile-push'
    | '/mobile-sms'
    | '/organization'
    | '/projects'
    | '/admin/email-abuse'
    | '/admin/organizations'
    | '/admin/users'
    | '/auth/$authView'
    | '/mcp/authorize'
    | '/mcp/sign-in'
    | '/admin/'
    | '/account/$accountView'
    | '/cli-project-select/$sessionId'
    | '/organization/api-keys'
    | '/organization/billing'
    | '/organization/mcp'
    | '/organization/members'
    | '/organization/sending'
    | '/organization/settings'
    | '/account/'
    | '/organization/'
    | '/projects/'
    | '/projects/$projectSlug'
    | '/cli-auth/$sessionId/'
    | '/cli-auth/$sessionId/complete/$organizationSlug'
    | '/projects/$projectSlug/about'
    | '/projects/$projectSlug/logs'
    | '/projects/$projectSlug/media'
    | '/projects/$projectSlug/sending'
    | '/projects/$projectSlug/settings'
    | '/projects/$projectSlug/virtual-inbox'
    | '/cli-auth/$sessionId/complete/'
    | '/projects/$projectSlug/'
    | '/projects/$projectSlug/templates/'
    | '/projects/$projectSlug/templates/$templateSlug/edit'
    | '/projects/$projectSlug/templates/$templateSlug/logs'
    | '/projects/$projectSlug/templates/$templateSlug/review'
    | '/projects/$projectSlug/templates/$templateSlug/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/mobile-push'
    | '/mobile-sms'
    | '/admin/email-abuse'
    | '/admin/organizations'
    | '/admin/users'
    | '/auth/$authView'
    | '/mcp/authorize'
    | '/mcp/sign-in'
    | '/'
    | '/admin'
    | '/account/$accountView'
    | '/cli-project-select/$sessionId'
    | '/organization/api-keys'
    | '/organization/billing'
    | '/organization/mcp'
    | '/organization/members'
    | '/organization/sending'
    | '/organization/settings'
    | '/account'
    | '/organization'
    | '/projects'
    | '/cli-auth/$sessionId'
    | '/cli-auth/$sessionId/complete/$organizationSlug'
    | '/projects/$projectSlug/about'
    | '/projects/$projectSlug/logs'
    | '/projects/$projectSlug/media'
    | '/projects/$projectSlug/sending'
    | '/projects/$projectSlug/settings'
    | '/projects/$projectSlug/virtual-inbox'
    | '/cli-auth/$sessionId/complete'
    | '/projects/$projectSlug'
    | '/projects/$projectSlug/templates'
    | '/projects/$projectSlug/templates/$templateSlug/edit'
    | '/projects/$projectSlug/templates/$templateSlug/logs'
    | '/projects/$projectSlug/templates/$templateSlug/review'
    | '/projects/$projectSlug/templates/$templateSlug'
  id:
    | '__root__'
    | '/_app'
    | '/admin'
    | '/mobile-push'
    | '/mobile-sms'
    | '/_app/organization'
    | '/_app/projects'
    | '/admin/email-abuse'
    | '/admin/organizations'
    | '/admin/users'
    | '/auth/$authView'
    | '/mcp/authorize'
    | '/mcp/sign-in'
    | '/_app/'
    | '/admin/'
    | '/_app/account/$accountView'
    | '/_app/cli-project-select/$sessionId'
    | '/_app/organization/api-keys'
    | '/_app/organization/billing'
    | '/_app/organization/mcp'
    | '/_app/organization/members'
    | '/_app/organization/sending'
    | '/_app/organization/settings'
    | '/_app/account/'
    | '/_app/organization/'
    | '/_app/projects/'
    | '/_app/projects/$projectSlug/_layout'
    | '/_app/cli-auth/$sessionId/'
    | '/_app/cli-auth/$sessionId/complete/$organizationSlug'
    | '/_app/projects/$projectSlug/_layout/about'
    | '/_app/projects/$projectSlug/_layout/logs'
    | '/_app/projects/$projectSlug/_layout/media'
    | '/_app/projects/$projectSlug/_layout/sending'
    | '/_app/projects/$projectSlug/_layout/settings'
    | '/_app/projects/$projectSlug/_layout/virtual-inbox'
    | '/_app/cli-auth/$sessionId/complete/'
    | '/_app/projects/$projectSlug/_layout/'
    | '/_app/projects/$projectSlug/templates/'
    | '/_app/projects/$projectSlug/templates/$templateSlug/edit'
    | '/_app/projects/$projectSlug/templates/$templateSlug/logs'
    | '/_app/projects/$projectSlug/templates/$templateSlug/review'
    | '/_app/projects/$projectSlug/templates/$templateSlug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  MobilePushRoute: typeof MobilePushRoute
  MobileSmsRoute: typeof MobileSmsRoute
  AuthAuthViewRoute: typeof AuthAuthViewRoute
  McpAuthorizeRoute: typeof McpAuthorizeRoute
  McpSignInRoute: typeof McpSignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile-push': {
      id: '/mobile-push'
      path: '/mobile-push'
      fullPath: '/mobile-push'
      preLoaderRoute: typeof MobilePushRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile-sms': {
      id: '/mobile-sms'
      path: '/mobile-sms'
      fullPath: '/mobile-sms'
      preLoaderRoute: typeof MobileSmsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/organization': {
      id: '/_app/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AppOrganizationRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/projects': {
      id: '/_app/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AppProjectsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/email-abuse': {
      id: '/admin/email-abuse'
      path: '/email-abuse'
      fullPath: '/admin/email-abuse'
      preLoaderRoute: typeof AdminEmailAbuseRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/organizations': {
      id: '/admin/organizations'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AdminOrganizationsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/auth/$authView': {
      id: '/auth/$authView'
      path: '/auth/$authView'
      fullPath: '/auth/$authView'
      preLoaderRoute: typeof AuthAuthViewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mcp/authorize': {
      id: '/mcp/authorize'
      path: '/mcp/authorize'
      fullPath: '/mcp/authorize'
      preLoaderRoute: typeof McpAuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mcp/sign-in': {
      id: '/mcp/sign-in'
      path: '/mcp/sign-in'
      fullPath: '/mcp/sign-in'
      preLoaderRoute: typeof McpSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/account/': {
      id: '/_app/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof AppAccountIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/account/$accountView': {
      id: '/_app/account/$accountView'
      path: '/account/$accountView'
      fullPath: '/account/$accountView'
      preLoaderRoute: typeof AppAccountAccountViewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/cli-project-select/$sessionId': {
      id: '/_app/cli-project-select/$sessionId'
      path: '/cli-project-select/$sessionId'
      fullPath: '/cli-project-select/$sessionId'
      preLoaderRoute: typeof AppCliProjectSelectSessionIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/organization/': {
      id: '/_app/organization/'
      path: '/'
      fullPath: '/organization/'
      preLoaderRoute: typeof AppOrganizationIndexRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/organization/api-keys': {
      id: '/_app/organization/api-keys'
      path: '/api-keys'
      fullPath: '/organization/api-keys'
      preLoaderRoute: typeof AppOrganizationApiKeysRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/organization/billing': {
      id: '/_app/organization/billing'
      path: '/billing'
      fullPath: '/organization/billing'
      preLoaderRoute: typeof AppOrganizationBillingRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/organization/mcp': {
      id: '/_app/organization/mcp'
      path: '/mcp'
      fullPath: '/organization/mcp'
      preLoaderRoute: typeof AppOrganizationMcpRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/organization/members': {
      id: '/_app/organization/members'
      path: '/members'
      fullPath: '/organization/members'
      preLoaderRoute: typeof AppOrganizationMembersRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/organization/sending': {
      id: '/_app/organization/sending'
      path: '/sending'
      fullPath: '/organization/sending'
      preLoaderRoute: typeof AppOrganizationSendingRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/organization/settings': {
      id: '/_app/organization/settings'
      path: '/settings'
      fullPath: '/organization/settings'
      preLoaderRoute: typeof AppOrganizationSettingsRouteImport
      parentRoute: typeof AppOrganizationRouteRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/cli-auth/$sessionId/': {
      id: '/_app/cli-auth/$sessionId/'
      path: '/cli-auth/$sessionId'
      fullPath: '/cli-auth/$sessionId/'
      preLoaderRoute: typeof AppCliAuthSessionIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/projects/$projectSlug/_layout': {
      id: '/_app/projects/$projectSlug/_layout'
      path: '/$projectSlug'
      fullPath: '/projects/$projectSlug'
      preLoaderRoute: typeof AppProjectsProjectSlugLayoutRouteRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/cli-auth/$sessionId/complete/': {
      id: '/_app/cli-auth/$sessionId/complete/'
      path: '/cli-auth/$sessionId/complete'
      fullPath: '/cli-auth/$sessionId/complete/'
      preLoaderRoute: typeof AppCliAuthSessionIdCompleteIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/cli-auth/$sessionId/complete/$organizationSlug': {
      id: '/_app/cli-auth/$sessionId/complete/$organizationSlug'
      path: '/cli-auth/$sessionId/complete/$organizationSlug'
      fullPath: '/cli-auth/$sessionId/complete/$organizationSlug'
      preLoaderRoute: typeof AppCliAuthSessionIdCompleteOrganizationSlugRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/projects/$projectSlug/_layout/': {
      id: '/_app/projects/$projectSlug/_layout/'
      path: '/'
      fullPath: '/projects/$projectSlug/'
      preLoaderRoute: typeof AppProjectsProjectSlugLayoutIndexRouteImport
      parentRoute: typeof AppProjectsProjectSlugLayoutRouteRoute
    }
    '/_app/projects/$projectSlug/_layout/about': {
      id: '/_app/projects/$projectSlug/_layout/about'
      path: '/about'
      fullPath: '/projects/$projectSlug/about'
      preLoaderRoute: typeof AppProjectsProjectSlugLayoutAboutRouteImport
      parentRoute: typeof AppProjectsProjectSlugLayoutRouteRoute
    }
    '/_app/projects/$projectSlug/_layout/logs': {
      id: '/_app/projects/$projectSlug/_layout/logs'
      path: '/logs'
      fullPath: '/projects/$projectSlug/logs'
      preLoaderRoute: typeof AppProjectsProjectSlugLayoutLogsRouteImport
      parentRoute: typeof AppProjectsProjectSlugLayoutRouteRoute
    }
    '/_app/projects/$projectSlug/_layout/media': {
      id: '/_app/projects/$projectSlug/_layout/media'
      path: '/media'
      fullPath: '/projects/$projectSlug/media'
      preLoaderRoute: typeof AppProjectsProjectSlugLayoutMediaRouteImport
      parentRoute: typeof AppProjectsProjectSlugLayoutRouteRoute
    }
    '/_app/projects/$projectSlug/_layout/sending': {
      id: '/_app/projects/$projectSlug/_layout/sending'
      path: '/sending'
      fullPath: '/projects/$projectSlug/sending'
      preLoaderRoute: typeof AppProjectsProjectSlugLayoutSendingRouteImport
      parentRoute: typeof AppProjectsProjectSlugLayoutRouteRoute
    }
    '/_app/projects/$projectSlug/_layout/settings': {
      id: '/_app/projects/$projectSlug/_layout/settings'
      path: '/settings'
      fullPath: '/projects/$projectSlug/settings'
      preLoaderRoute: typeof AppProjectsProjectSlugLayoutSettingsRouteImport
      parentRoute: typeof AppProjectsProjectSlugLayoutRouteRoute
    }
    '/_app/projects/$projectSlug/_layout/virtual-inbox': {
      id: '/_app/projects/$projectSlug/_layout/virtual-inbox'
      path: '/virtual-inbox'
      fullPath: '/projects/$projectSlug/virtual-inbox'
      preLoaderRoute: typeof AppProjectsProjectSlugLayoutVirtualInboxRouteImport
      parentRoute: typeof AppProjectsProjectSlugLayoutRouteRoute
    }
    '/_app/projects/$projectSlug/templates/': {
      id: '/_app/projects/$projectSlug/templates/'
      path: '/$projectSlug/templates'
      fullPath: '/projects/$projectSlug/templates/'
      preLoaderRoute: typeof AppProjectsProjectSlugTemplatesIndexRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/$projectSlug/templates/$templateSlug/': {
      id: '/_app/projects/$projectSlug/templates/$templateSlug/'
      path: '/$projectSlug/templates/$templateSlug'
      fullPath: '/projects/$projectSlug/templates/$templateSlug/'
      preLoaderRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugIndexRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/$projectSlug/templates/$templateSlug/edit': {
      id: '/_app/projects/$projectSlug/templates/$templateSlug/edit'
      path: '/$projectSlug/templates/$templateSlug/edit'
      fullPath: '/projects/$projectSlug/templates/$templateSlug/edit'
      preLoaderRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugEditRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/$projectSlug/templates/$templateSlug/logs': {
      id: '/_app/projects/$projectSlug/templates/$templateSlug/logs'
      path: '/$projectSlug/templates/$templateSlug/logs'
      fullPath: '/projects/$projectSlug/templates/$templateSlug/logs'
      preLoaderRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugLogsRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/$projectSlug/templates/$templateSlug/review': {
      id: '/_app/projects/$projectSlug/templates/$templateSlug/review'
      path: '/$projectSlug/templates/$templateSlug/review'
      fullPath: '/projects/$projectSlug/templates/$templateSlug/review'
      preLoaderRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugReviewRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
  }
}

interface AppOrganizationRouteRouteChildren {
  AppOrganizationApiKeysRoute: typeof AppOrganizationApiKeysRoute
  AppOrganizationBillingRoute: typeof AppOrganizationBillingRoute
  AppOrganizationMcpRoute: typeof AppOrganizationMcpRoute
  AppOrganizationMembersRoute: typeof AppOrganizationMembersRoute
  AppOrganizationSendingRoute: typeof AppOrganizationSendingRoute
  AppOrganizationSettingsRoute: typeof AppOrganizationSettingsRoute
  AppOrganizationIndexRoute: typeof AppOrganizationIndexRoute
}

const AppOrganizationRouteRouteChildren: AppOrganizationRouteRouteChildren = {
  AppOrganizationApiKeysRoute: AppOrganizationApiKeysRoute,
  AppOrganizationBillingRoute: AppOrganizationBillingRoute,
  AppOrganizationMcpRoute: AppOrganizationMcpRoute,
  AppOrganizationMembersRoute: AppOrganizationMembersRoute,
  AppOrganizationSendingRoute: AppOrganizationSendingRoute,
  AppOrganizationSettingsRoute: AppOrganizationSettingsRoute,
  AppOrganizationIndexRoute: AppOrganizationIndexRoute,
}

const AppOrganizationRouteRouteWithChildren =
  AppOrganizationRouteRoute._addFileChildren(AppOrganizationRouteRouteChildren)

interface AppProjectsProjectSlugLayoutRouteRouteChildren {
  AppProjectsProjectSlugLayoutAboutRoute: typeof AppProjectsProjectSlugLayoutAboutRoute
  AppProjectsProjectSlugLayoutLogsRoute: typeof AppProjectsProjectSlugLayoutLogsRoute
  AppProjectsProjectSlugLayoutMediaRoute: typeof AppProjectsProjectSlugLayoutMediaRoute
  AppProjectsProjectSlugLayoutSendingRoute: typeof AppProjectsProjectSlugLayoutSendingRoute
  AppProjectsProjectSlugLayoutSettingsRoute: typeof AppProjectsProjectSlugLayoutSettingsRoute
  AppProjectsProjectSlugLayoutVirtualInboxRoute: typeof AppProjectsProjectSlugLayoutVirtualInboxRoute
  AppProjectsProjectSlugLayoutIndexRoute: typeof AppProjectsProjectSlugLayoutIndexRoute
}

const AppProjectsProjectSlugLayoutRouteRouteChildren: AppProjectsProjectSlugLayoutRouteRouteChildren =
  {
    AppProjectsProjectSlugLayoutAboutRoute:
      AppProjectsProjectSlugLayoutAboutRoute,
    AppProjectsProjectSlugLayoutLogsRoute:
      AppProjectsProjectSlugLayoutLogsRoute,
    AppProjectsProjectSlugLayoutMediaRoute:
      AppProjectsProjectSlugLayoutMediaRoute,
    AppProjectsProjectSlugLayoutSendingRoute:
      AppProjectsProjectSlugLayoutSendingRoute,
    AppProjectsProjectSlugLayoutSettingsRoute:
      AppProjectsProjectSlugLayoutSettingsRoute,
    AppProjectsProjectSlugLayoutVirtualInboxRoute:
      AppProjectsProjectSlugLayoutVirtualInboxRoute,
    AppProjectsProjectSlugLayoutIndexRoute:
      AppProjectsProjectSlugLayoutIndexRoute,
  }

const AppProjectsProjectSlugLayoutRouteRouteWithChildren =
  AppProjectsProjectSlugLayoutRouteRoute._addFileChildren(
    AppProjectsProjectSlugLayoutRouteRouteChildren,
  )

interface AppProjectsRouteRouteChildren {
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppProjectsProjectSlugLayoutRouteRoute: typeof AppProjectsProjectSlugLayoutRouteRouteWithChildren
  AppProjectsProjectSlugTemplatesIndexRoute: typeof AppProjectsProjectSlugTemplatesIndexRoute
  AppProjectsProjectSlugTemplatesTemplateSlugEditRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugEditRoute
  AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute
  AppProjectsProjectSlugTemplatesTemplateSlugReviewRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugReviewRoute
  AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute: typeof AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute
}

const AppProjectsRouteRouteChildren: AppProjectsRouteRouteChildren = {
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppProjectsProjectSlugLayoutRouteRoute:
    AppProjectsProjectSlugLayoutRouteRouteWithChildren,
  AppProjectsProjectSlugTemplatesIndexRoute:
    AppProjectsProjectSlugTemplatesIndexRoute,
  AppProjectsProjectSlugTemplatesTemplateSlugEditRoute:
    AppProjectsProjectSlugTemplatesTemplateSlugEditRoute,
  AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute:
    AppProjectsProjectSlugTemplatesTemplateSlugLogsRoute,
  AppProjectsProjectSlugTemplatesTemplateSlugReviewRoute:
    AppProjectsProjectSlugTemplatesTemplateSlugReviewRoute,
  AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute:
    AppProjectsProjectSlugTemplatesTemplateSlugIndexRoute,
}

const AppProjectsRouteRouteWithChildren =
  AppProjectsRouteRoute._addFileChildren(AppProjectsRouteRouteChildren)

interface AppRouteRouteChildren {
  AppOrganizationRouteRoute: typeof AppOrganizationRouteRouteWithChildren
  AppProjectsRouteRoute: typeof AppProjectsRouteRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppAccountAccountViewRoute: typeof AppAccountAccountViewRoute
  AppCliProjectSelectSessionIdRoute: typeof AppCliProjectSelectSessionIdRoute
  AppAccountIndexRoute: typeof AppAccountIndexRoute
  AppCliAuthSessionIdIndexRoute: typeof AppCliAuthSessionIdIndexRoute
  AppCliAuthSessionIdCompleteOrganizationSlugRoute: typeof AppCliAuthSessionIdCompleteOrganizationSlugRoute
  AppCliAuthSessionIdCompleteIndexRoute: typeof AppCliAuthSessionIdCompleteIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppOrganizationRouteRoute: AppOrganizationRouteRouteWithChildren,
  AppProjectsRouteRoute: AppProjectsRouteRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppAccountAccountViewRoute: AppAccountAccountViewRoute,
  AppCliProjectSelectSessionIdRoute: AppCliProjectSelectSessionIdRoute,
  AppAccountIndexRoute: AppAccountIndexRoute,
  AppCliAuthSessionIdIndexRoute: AppCliAuthSessionIdIndexRoute,
  AppCliAuthSessionIdCompleteOrganizationSlugRoute:
    AppCliAuthSessionIdCompleteOrganizationSlugRoute,
  AppCliAuthSessionIdCompleteIndexRoute: AppCliAuthSessionIdCompleteIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AdminRouteRouteChildren {
  AdminEmailAbuseRoute: typeof AdminEmailAbuseRoute
  AdminOrganizationsRoute: typeof AdminOrganizationsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminEmailAbuseRoute: AdminEmailAbuseRoute,
  AdminOrganizationsRoute: AdminOrganizationsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  MobilePushRoute: MobilePushRoute,
  MobileSmsRoute: MobileSmsRoute,
  AuthAuthViewRoute: AuthAuthViewRoute,
  McpAuthorizeRoute: McpAuthorizeRoute,
  McpSignInRoute: McpSignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
